import React from 'react';
import { Switch, Route } from 'react-router-dom';
import HomePage from '../HomePage';
import { NotFoundPage } from '../../components/NotFoundPage';
import RemindersPage from '../RemindersPage';
import Appeal from '../Appeal';
import About from '../About';
import {
  ROUTE_HOME,
  ROUTE_REMINDERS,
  ROUTE_CREATE_REQUEST,
  ROUTE_ONE_APPEAL,
  ROUTE_ABOUT,
  ROUTE_FAQ
} from '../../constants/routes';
import CreateRequestPage from '../CreateRequestPage';
import Faq from '../Faq';

export default function Routes({ location }) {
  return (
    <Switch location={location}>
      <Route
        exact
        path={ROUTE_HOME}
        component={HomePage}
      />
      <Route
        exact
        path={ROUTE_CREATE_REQUEST}
        component={CreateRequestPage}
      />
      <Route
        exact
        path={ROUTE_REMINDERS}
        component={RemindersPage}
      />
      <Route
        exact
        path={ROUTE_ONE_APPEAL}
        component={Appeal}
      />
      <Route
        exact 
        path={ROUTE_ABOUT}
        component={About}
      />
      <Route
        exact 
        path={ROUTE_FAQ}
        component={Faq}
      />
      <Route
        component={NotFoundPage}
      />
    </Switch>
  );
}
